import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { catalogPath } from "@/lib/url-slugs";
import brandStarvie from "@/assets/brand-starvie.webp";
import brandAdidas from "@/assets/brand-adidas.jpg";
import brandHead from "@/assets/brand-head.webp";
import brandNox from "@/assets/brand-nox.jpg";
import brandSiux from "@/assets/brand-siux.webp";
import brandWilson from "@/assets/brand-wilson.png";
import brandBullpadel from "@/assets/brand-bullpadel.png";

const secondaryBrands = [
  { name: "Adidas", brand: "adidas", logo: brandAdidas },
  { name: "Head", brand: "head", logo: brandHead },
  { name: "Nox", brand: "nox", logo: brandNox },
  { name: "SIUX", brand: "siux", logo: brandSiux },
  { name: "Wilson", brand: "wilson", logo: brandWilson },
  { name: "Bullpadel", brand: "bullpadel", logo: brandBullpadel },
];


const BrandButtons = () => {
  const { lang } = useLanguage();

  return (
    <section className="container mx-auto px-4 py-8 md:py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto">
        {/* Starvie – hero tile: full width on mobile, left column spanning 2 rows on desktop */}
        <Link
          to={catalogPath(lang, "rackets", "starvie")}
          className="group relative flex items-center justify-center rounded-2xl overflow-hidden bg-card border border-primary/20 shadow-[0_0_20px_-3px_hsl(var(--primary)/0.35)] hover:shadow-[0_0_35px_-3px_hsl(var(--primary)/0.55)] hover:border-primary/50 transition-all duration-300 min-h-[220px] md:min-h-[320px] md:row-span-2"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-primary/5" />
          <img
            src={brandStarvie}
            alt="Starvie"
            className="relative z-10 w-[85%] max-w-[320px] object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
          />
        </Link>

        {/* Right column: 3 brands per row, 2 rows = 6 secondary brands */}
        <div className="grid grid-cols-3 gap-3">
          {secondaryBrands.map((brand) => (
            <Link
              key={brand.name}
              to={catalogPath(lang, "rackets", brand.brand)}
              className="group relative flex items-center justify-center rounded-xl overflow-hidden bg-card border border-border hover:border-primary/40 shadow-sm hover:shadow-[0_0_15px_-3px_hsl(var(--primary)/0.25)] transition-all duration-300 min-h-[70px] md:min-h-[148px]"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="relative z-10 h-10 md:h-14 max-w-[85%] object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandButtons;
